import { render, staticRenderFns } from "./hot-table-edit-features.vue?vue&type=template&id=96e8e93e&scoped=true&"
import script from "./hot-table-edit-features.vue?vue&type=script&lang=js&"
export * from "./hot-table-edit-features.vue?vue&type=script&lang=js&"
import style0 from "./hot-table-edit-features.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./hot-table-edit-features.vue?vue&type=style&index=1&id=96e8e93e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e8e93e",
  null
  
)

export default component.exports